// extracted by mini-css-extract-plugin
export default {"scrollable-content":"MainComponent_scrollable-content__HEI5S","mainDiv":"MainComponent_mainDiv__4KN+I","childDiv":"MainComponent_childDiv__+THSU"};